import { render, staticRenderFns } from "./CityAvatar.vue?vue&type=template&id=ef7c6d50&scoped=true"
import script from "./CityAvatar.vue?vue&type=script&lang=ts"
export * from "./CityAvatar.vue?vue&type=script&lang=ts"
import style0 from "./CityAvatar.vue?vue&type=style&index=0&id=ef7c6d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7c6d50",
  null
  
)

export default component.exports